import React from "react";
import { InfoCard } from "best-common-react";

const ComptixAssignedAccountInformation = params => {
  if (params.dsn == null || params.accounts == null) {
    return <div>Loading</div>;
  } else if (params.dsn === "") {
    return <div>Not a TM Club</div>;
  } else {
    return (
      <InfoCard className="mt-2" backgroundColor="white" title="Account Info">
        <div style={{ fontWeight: "bold" }}>
          DSN: <span style={{ fontWeight: "normal" }}>{params.dsn}</span>
        </div>
        <div style={{ fontWeight: "bold" }}>
          Home account: <span style={{ fontWeight: "normal" }}>{params.accounts?.home.username}</span>
        </div>
        <div style={{ fontWeight: "bold" }}>
          Away account: <span style={{ fontWeight: "normal" }}> {params.accounts?.away.username}</span>
        </div>
        <div style={{ fontWeight: "bold" }}>
          Umpire account: <span style={{ fontWeight: "normal" }}>{params.accounts?.umpire.username}</span>
        </div>
      </InfoCard>
    );
  }
};

export default ComptixAssignedAccountInformation;
